import {
  DownOutlined,
  MinusCircleOutlined,
  PlusOutlined,
  UpOutlined,
} from "@ant-design/icons";
import { Button } from "antd";
import { memo, useEffect, useState } from "react";
import Question from "../Question/Question";
import MultiOption from "../MultiOption/MultiOption";
import ShortAnswer from "../ShortAnswer/ShortAnswer";
import reorder from "../../../Util/reorder";

const MultiText = ({
  index,
  id,
  noNumber,
  disabled,
  field_type,
  label,
  options,
  required,
  description,
  onChange,
  newQuestionId,
  setNewQuestionId,
  onRemove,
  duplicateQuestion,
  formContainer,
  question_number,
}) => {
  const [arrayQuestions, setArrayOfQuestions] = useState([]);
  const [showQuestions, setShowQuestions] = useState(false);

  useEffect(() => {
    if (options && arrayQuestions.length === 0) {
      setArrayOfQuestions(options);
    }
  }, [options]);

  const addQuestion = () => {
    const oldQuestions = arrayQuestions;
    const newQuestions = [...oldQuestions, { id: newQuestionId }];
    setNewQuestionId(newQuestionId + 1);
    setArrayOfQuestions(newQuestions);
    onChange("options", newQuestions);
  };
  const removeSubQuestion = (id) => {
    const newQuestions = [];
    const oldQuestions = arrayQuestions;
    oldQuestions.forEach((opt) => {
      if (opt.id !== id) {
        newQuestions.push(opt);
      }
    });
    setArrayOfQuestions([]);
    setTimeout(() => {
      setArrayOfQuestions(newQuestions);
    }, 1);
    onChange("options", newQuestions);
  };
  const editQuestion = (id, field, value) => {
    const oldQuestions = arrayQuestions;
    const newQuestions = oldQuestions.map((opt) => {
      if (opt.id === id) {
        const newOpt = opt;
        newOpt[field] = value;
        return newOpt;
      }
      return opt;
    });
    setArrayOfQuestions(newQuestions);
    onChange("options", newQuestions);
  };
  return (
    <Question
      question_number={question_number}
      formContainer={formContainer}
      duplicateQuestion={duplicateQuestion}
      onChange={onChange}
      description={description}
      required={required}
      label={label}
      index={index}
      id={id}
      // type={noNumber ? `${noNumber} - چند متن` : "چند متن"}
      type={"چند متن"}
      disabled={disabled}
      onRemove={onRemove}
    >
      <Button
        style={{ width: "100%", marginBottom: "0.5rem" }}
        onClick={() => {
          setShowQuestions(!showQuestions);
        }}
        type="ghost"
        icon={showQuestions ? <UpOutlined /> : <DownOutlined />}
      >
        سوال‌ها
      </Button>
      {showQuestions &&
        arrayQuestions.map((question, index) => {
          return (
            <>
              <ShortAnswer
                formContainer={true}
                index={index}
                onRemove={() => {
                  removeSubQuestion(question.id);
                }}
                reOrder={reorder(
                  arrayQuestions,
                  setArrayOfQuestions,
                  onChange,
                  "options",
                  index
                )}
                noDetail
                {...question}
                onChange={(field, value) => {
                  editQuestion(question.id, field, value);
                }}
              />
            </>
          );
        })}
      {showQuestions && (
        <Button
          disabled={disabled}
          type="dashed"
          onClick={() => addQuestion()}
          style={{
            width: "100%",
          }}
          icon={<PlusOutlined />}
        >
          اضافه کردن سوال
        </Button>
      )}
    </Question>
  );
};

export default memo(MultiText);
